export const custom = {
  /**
  * Idiomas disponibles ['es','en','pt','cat']
  */
  availableLangs: ['es'],

  /**
   * Idioma por defecto: ['es']
   */
  defaultLang: 'es',

  /**
   * Versión de la API: v2|v3
   */
  apiVersion: 'v3',

  /**
   * API key de conexión a la api definida en cada entorno
   * (debe ser el mismo en todos los servicios)
   */
  apiKey: 'f070e02b-7ccb-4b03-a815-70d5d9000b8d',

  /**
   * Extensión en producción de URL de la app
   * (es, com, org...)
   */
   appUrlTld: 'com',

  /**
   * URL de la app
   *
   * subdominio.dominio
   */
  appUrlDomain: 'vivofacilessenceosce.vivofacil',

  /**
  * Nombre de la app
  */
  appName: 'Vivofacil Essence OSCE',

  /**
   * Nombre de marca interno (Alares, Vivofácil...)
   */
   brandName: 'Vivofácil',

  /**
   * Mail transport (alares, vivofacil...)
   */
   mailTransport: 'vivofacil',

  /**
  * Código de analytics 'G-XXXXXXXXXXX'
  * (Activado en pro, desactivado en pre y local)
  */
  analyticsId: 'G-S1PG9JPYVB',

  /** true o false. Define si es necesario hacer login para acceder a los contenidos */
  protected: true,

  /** Registro habilitado o deshabilitado */
  registration: true,

  /** true o false. Define si los formularios son para conciliación o no */
  conciliation: false,

  /** numero de telefono o false. Si es false no se muestra el icono de whatsapp en las páginas */
  whatsapp: false,

  /** true of false. Define si se muestra el botón para volver al inicio */
  homeButton: false,

  /** true o false. Define si se muestra el area privada */
  showPrivateArea: false,

  /** Se permiten contraseñas no seguras */
  allowInsecurePasswords: false,

  /**
   * Api Key de Google Maps
   * Valores: false|<clave_publica>
   */
  googleMapsApiKey: 'AIzaSyAnoowlhGOt23DWy0YI7j5R7tbBCrCqYs0',

  /** testamentis */
  testamentisHereditary: 'https://formularios.alares.local/form/create/1edaeaf3-6bc3-651c-ae2c-1b9a90d4d278/embed',
  testamentisLiving: 'https://formularios.alares.local/form/create/1ed08dea-bf79-6442-8808-436f6414e40d/embed'
};
